import React from "react";
import { testimonial } from "../data/Data";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Sliders() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
  };
  return (
    <>
      <div
        className="my-5 py-5 bg-dark wow zoomIn"
        data-wow-delay="0.1s"
      >
        <div className="owl-carousel testimonial-carousel">
        {/* <div className="owl-carousel"> */}
          <div className="">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14083.479582532531!2d76.421748!3d28.0589969!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3912ab0071a8b78b%3A0x627fd593795237bf!2sBGM%20Hotel!5e0!3m2!1sen!2sin!4v1730086049452!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-aos="zoom-in-down"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
}
